import React from 'react';
import { Col, DatePicker, Form, FormInstance, Row } from 'antd';
import CollapseCommon from 'components/common/Collapse/CollapseCommon';
import LabelWithRequired from 'components/common/Label/LabelWithRequired';
import { InputCommon } from 'components/common/Input/InputCommon';
import SelectCommon from 'components/common/Select/SelectCommon';
import { emailRules, phoneNumber, timeCreate, userName } from 'utils/formRules';
import BarcodeCommon from 'components/common/Barcode/BarcodeCommon';
import { CalendarBlank, CaretDown } from '@phosphor-icons/react';
import { useGetStaffsQuery } from 'services';
import { Supplier } from 'models';
export interface ReturnOrderInfoProps {
  form: FormInstance;
  handleCreatecode: () => void;
  handleBarcode: () => void;
  selectedSupplierId: string | number | undefined;
  setSelectedSupplierId?: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  suppliers?: Supplier[];
}

const ReturnOrderInfo: React.FC<ReturnOrderInfoProps> = ({ form, handleBarcode, setSelectedSupplierId, suppliers }) => {
  const { data: staff } = useGetStaffsQuery({
    query: {
      include: 'baseUser',
    },
  });

  return (
    <div className='flex flex-col gap-6 h-full'>
      <CollapseCommon
        title='THÔNG TIN ĐƠN TRẢ HÀNG'
        collapseKey='info'
        hideExpandIcon
        disableCollapse
        size='md'
        className='!my-0 h-full'
      >
        <Form form={form} layout='vertical'>
          <Row gutter={[24, 12]}>
            <Col span={8}>
              <Form.Item label={<LabelWithRequired label='Mã trả' />} name='code' className='mb-0'>
                <InputCommon type='text' placeholder='Nhập vào mã...' className='!px-3 text-sm' />
              </Form.Item>
            </Col>
            <Col xl={8}>
              <Form.Item
                label={<LabelWithRequired label='Nhà cung cấp' />}
                required={false}
                name='supplierId'
                className='mb-0'
                rules={[{ required: true, message: 'Vui lòng chọn nhà cung cấp!' }]}
              >
                <SelectCommon
                  placeholderSelect='Chọn nhà cung cấp'
                  options={suppliers?.map((supplier) => ({
                    label: supplier?.baseUser?.name ?? '',
                    value: supplier?.id,
                  }))}
                  onChange={(value) => setSelectedSupplierId && setSelectedSupplierId(value)}
                  selectType='filterSelect'
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item shouldUpdate className='mb-0'>
                {() => (
                  <Form.Item label={<LabelWithRequired label='Barcode' />} name='barcode' className='mb-0'>
                    <BarcodeCommon
                      displayGenerate={false}
                      valueBarcode={form.getFieldValue('barcode')}
                      onGenerate={handleBarcode}
                    />
                  </Form.Item>
                )}
              </Form.Item>
            </Col>
            {form.getFieldValue('returnFromOrder') && (
              <Col span={8}>
                <Form.Item
                  label={<LabelWithRequired label='Trả từ đơn' />}
                  required={false}
                  name='returnFromOrder'
                  className='mb-0'
                >
                  <InputCommon className='!text-[var(--textBlack100)]' disabled suffix={<CaretDown size={20} />} />
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item label='Mô tả đơn hàng' required={false} name='describeOrder' className='mb-0 '>
                <InputCommon type='textarea' placeholder='Nhập mô tả đơn hàng...' className='text-sm' />
              </Form.Item>
            </Col>
          </Row>
          <h1 className='text-[20px] py-5 leading-[24px] font-semibold -ml-6'>THÔNG TIN NGƯỜI TRẢ</h1>
          <Row gutter={[24, 12]}>
            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='Họ và tên' />}
                rules={userName}
                required={false}
                name='userName'
                className='mb-0'
              >
                <SelectCommon
                  placeholderSelect='Chọn hoặc nhập vào họ tên'
                  options={staff?.data?.rows?.map((staff) => ({
                    label: staff?.baseUser?.name ?? '',
                    value: staff?.baseUser?.name ?? '',
                  }))}
                  selectType='filterSelect'
                  onChange={(value) => {
                    const selected = staff?.data?.rows?.find((sup) => sup.baseUser?.name === value);
                    if (selected) {
                      form.setFieldsValue({
                        phoneNumber: selected.baseUser?.phoneNumber || '',
                        email: selected.baseUser?.email || '',
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='Số điện thoại' />}
                required={false}
                rules={phoneNumber}
                name='phoneNumber'
                className='mb-0'
              >
                <InputCommon type='text' placeholder='Nhập vào số điện thoại' className='!px-3 text-sm' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='Email' />}
                required={false}
                rules={emailRules}
                name='email'
                className='mb-0 '
              >
                <InputCommon type='text' placeholder='Nhập vào Email' className='!px-3 text-sm' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='Thời gian trả hàng' />}
                required={false}
                rules={timeCreate}
                name='deliveryDate'
                className='mb-0'
              >
                <DatePicker
                  className='w-full h-[30px] xl:h-[36px] 2xl:h-[40px]'
                  placeholder='Chọn ngày nhập hàng'
                  format='DD/MM/YYYY'
                  suffixIcon={<CalendarBlank className='text-[var(--textBlack100)]' />}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label='Ghi chú' required={false} name='describeNote' className='mb-0 '>
                <InputCommon type='textarea' placeholder='Nhập ghi chú...' className='text-sm' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CollapseCommon>
    </div>
  );
};

export default ReturnOrderInfo;
